import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalDataSource } from 'ng2-smart-table';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';
import { StationService } from '../../../services/stations.service';
import { SasisopaService } from '../../../services/sasisopa.service';
import { EditCreateDeleteComponent } from './edit-create-delete/edit-create-delete.component';
import { NbDialogService } from '@nebular/theme';
import { EmployeeService } from '../../../employee.service';

@Component({
  selector: 'ngx-document-detail-sasisopa',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  stationId: string;
  loading = false;
  data = { name: '', custom_procedure: null, procedure_number: 0, url_image: 'https://cdn-icons-png.flaticon.com/512/3286/3286271.png', document: { code: '', name: ''} }
  item = { id: 0, name: '', code: '', date: new Date(), id_responsable: '', type: '' }
  sourceData: LocalDataSource;
  dataForManager = { documents: [], id: 0, type: 'detail', name: '', uploadPath: '' };
  employees = {}
  settings: any = {
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        { name: 'edit', title: '<img src="assets/images/icons/edit.svg" class="mx-1 hover-cursor-pointer" width="35px">' },
        { name: 'delete', title: '<img src="assets/images/icons/delete.svg" class="mx-1 hover-cursor-pointer" width="35px">' },
        { name: 'folder', title: '<img src="assets/images/icons/folder.svg" class="mx-1 hover-cursor-pointer" width="35px">' }
      ]
    },
    pager: { perPage: 15 },
    columns: {
      name: { title: 'Nombre', filter: true },
      code: { title: 'Código', filter: true },
      id_responsable: { title: 'Responsable', filter: true, valuePrepareFunction: (id_responsable) => this.employees[id_responsable] ? this.employees[id_responsable].name : 'No asignado' },
      type: { title: 'Tipo de documento', filter: true },
      attacheds: { title: '# Archivos', filter: true, valuePrepareFunction: (attacheds) => attacheds.length },
      date: { title: 'Fecha de establecida', filter: true, valuePrepareFunction: (date) => moment(date).format('ll') }
    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private stationService: StationService,
    public route: ActivatedRoute,
    private sasisopaService: SasisopaService,
    private dialogService: NbDialogService,
    private employeeService: EmployeeService,
    public router: Router,
    ) {
    this.stationId =  this.route.snapshot.params.stationId;
    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.router.navigate(['/pages/implementacion-sasisopa', station]);
    });
  }

  async ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    await this.getEmployees()
    await this.getDocuments()
  }

  async getEmployees () {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    for await (const employee of result.data) this.employees[employee.id] = employee
  }

  async getDocuments () {
    this.loading = true;
    const [error, response] = await this.sasisopaService.getDetailsByStationDocumentId(this.stationId, this.route.snapshot.params.procedureId, this.route.snapshot.params.documentId)
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    // console.error(response.data)
    this.data = response.data
    this.sourceData = response.data.document.details
  }

  onCustom ($event) {
    if ($event.action === 'edit') {
      this.item = $event.data
      this.showModalCreateOrEdit($event.action)
    } else if ($event.action === 'delete') {
      this.item = $event.data
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if ($event.action === 'folder') {
      this.dataForManager.id = $event.data.id
      this.dataForManager.documents = $event.data.attacheds
      this.dataForManager.name = $event.data.name
      this.dataForManager.uploadPath = `images/sasisopa/${this.stationId}/procedimiento${this.route.snapshot.params.procedureId}`
      // @ts-ignore
      $('#modal-manager-files-sasisopa').modal('show')
    } else if ($event.action === 'detail') {
      this.router.navigate(['/pages/implementacion-sasisopa', this.stationId, 'procedimiento', this.route.snapshot.params.procedureId, 'documento', $event.data.id, 'detalle']);
    }
  }

  async showModalCreateOrEdit (action = 'create') {
    if (action === 'create') this.item = { id: 0, name: '', code: '', date: new Date(), id_responsable: '', type: '' }
    this.dialogService.open(EditCreateDeleteComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        item: this.item,
        documentId: this.route.snapshot.params.documentId,
        action
      },
    }).onClose.subscribe(response => response ? this.ngOnInit() : null);
  }

  async deleteDocument () {
    this.loading = true;
    const [error] = await this.sasisopaService.deleteDocumentDetail(this.item.id)
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    this.loading = false;
    // @ts-ignore
    $('#delete-document').modal('hide');
    this.getDocuments()
    return this.alert('Éxito', 'success', 'Se elimino el detalle');
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
